/** 
 * @TercioSantos-1 |
 * api/get/todas as configurações de 1 empresa |
 * api/get/1 configuração específica |
 * api/put/atualização de 1 configuração |
 */
import api from "../../services/api";

// Cache simples em memória para evitar requisições repetidas por sessão
// Observação: pode ser ignorado por chamada usando params.noCache === true
const __settingsCache = {
    manualTicketCreation: { loaded: false, value: null }
};

const useCompanySettings = () => {

    const getAll = async (companyId) => {
        const { data } = await api.request({
            url: `/companySettings/${companyId}`,
            method: 'GET'
        });

        return data;
    }

   const get = async (params) => {
        const noCache = Boolean(params && params.noCache);
        // Retorna do cache somente se permitido e já carregado
        if (!noCache && params && params.column === 'manualTicketCreation' && __settingsCache.manualTicketCreation.loaded) {
            return { manualTicketCreation: __settingsCache.manualTicketCreation.value };
        }
        const { data } = await api.request({
            url: '/companySettingOne',
            method: 'GET',
            params
        });
        // Atualiza cache quando for manualTicketCreation
        if (params && params.column === 'manualTicketCreation') {
            const val = data && typeof data.manualTicketCreation !== 'undefined' ? data.manualTicketCreation : null;
            __settingsCache.manualTicketCreation.loaded = true;
            __settingsCache.manualTicketCreation.value = val;
        }
        return data;
    } 

    const update = async (data) => {
        const { data: responseData } = await api.request({
            url: '/companySettings',
            method: 'PUT',
            data
        });
        // Ajusta cache caso a atualização seja de manualTicketCreation
        try {
            if (data && (data.key === 'manualTicketCreation' || typeof data.manualTicketCreation !== 'undefined')) {
                const v = data.key === 'manualTicketCreation' ? data.value : data.manualTicketCreation;
                __settingsCache.manualTicketCreation.loaded = true;
                __settingsCache.manualTicketCreation.value = v;
            }
        } catch {}
        return responseData;
    }

    return {
        getAll,
        get,
        update
    }
}

export default useCompanySettings;